import React from 'react'

import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { EventContext, useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import RatedTag from '../../../RatedTag'

import classes from './ProductCard.module.scss'

/** @type {import("./types").default} */
const ProductCard = ({ listing }) => {
  const { addEvent } = useEventContext({})
  const { up, is } = useViewport()

  const isDesktop = up('lg')
  const isTablet = up('sm') && !isDesktop
  const isMobile = is('xs')

  const logoSize = isDesktop ? 64 : isTablet ? 56 : 40

  const handleSmoothScroll = evt => {
    evt.preventDefault()
    const targetId = `listing-${listing.slug}`
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  return (
    <>
      {isMobile && listing.highly_rated_for && (
        <RatedTag tagKey={listing.highly_rated_for} className={classes.ratedTag} />
      )}
      <div className={classes.root}>
        <Logo className={classes.logo} src={`${listing.logo_url}`} alt={`${listing.name} logo`} size={logoSize} />
        <div className={classes.info}>
          <Link
            className={classes.title}
            onClick={handleSmoothScroll}
            {...addEvent({
              engagementComponent: 'best-products_list',
              engagementDetails: 'text-link_product-name',
              engagementDestination: 'go-to_best-product_card-item',
              name: 'engagement_product_click',
            })}
          >
            {listing.name}
          </Link>
          {isDesktop && listing.highly_rated_for ? (
            <RatedTag tagKey={listing.highly_rated_for} />
          ) : (
            !isDesktop && (
              <EventContext value={{ engagementComponent: 'best-products_list' }}>
                <Rating.Link
                  isCompact
                  average={listing.rating_avg}
                  totals={listing.num_reviews}
                  href={listing.cta_urls.reviews}
                />
              </EventContext>
            )
          )}
        </div>
      </div>
      {isTablet && listing.highly_rated_for && <RatedTag tagKey={listing.highly_rated_for} />}
    </>
  )
}

export default ProductCard
